import React, { Component } from 'react';
// import videojs from 'video.js'
import VideoPlayer from './VideoPlayer';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';

class Feedback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feedbackText: ""
    }

    this.updateFeedback = this.updateFeedback.bind(this);
    this.submitFeedback = this.submitFeedback.bind(this);
  }

  updateFeedback(e) {
    this.setState({
      feedbackText: e.target.value
    });
  }

  submitFeedback(e) {
    e.preventDefault();

    if(this.state.feedbackText.length > 0) {
      this.props.saveFeedback({
        feedbackText: this.state.feedbackText,
        videoID: this.props.videoID
      });
    } else {
      this.props.showAlert("danger","Please enter some feedback.");
    }
  }

  render() {
    const videoJsOptions = {
      autoplay: false,
      controls: true,
      sources: [{
        src: this.props.videoURL,
        type: 'video/mp4'
      }]
    };

    return (
      <div className="Step Feedback">
      {!this.props.noVideo &&
        <div>
        {this.props.headline && (<h1>{this.props.headline}</h1>)}
        {this.props.videoID && <div className="fit-vid">
          <VideoPlayer { ...videoJsOptions } />
        </div>}
        {this.props.description && <div className="my-3" dangerouslySetInnerHTML={this.props.createMarkup(this.props.description)} />}
        <Form>
          <FormGroup className="my-3">
            <Label for="feedbackText">Your feedback</Label>
            <Input key={this.props.videoURL} type="textarea" name="text" id="feedbackText" defaultValue="" onChange={this.updateFeedback} />
          </FormGroup>
        </Form>
        <Button color="primary" className="float-right" onClick={this.submitFeedback}>{this.props.buttonNext}</Button>
        </div>
      }
      {this.props.noVideo &&
        <div>
          <p>We don't have any other videos for you to review right now.</p>
          <Button color="primary" className="float-right" onClick={this.advanceStep}>Next</Button>
        </div>
      }
      </div>
    );
  }
}

export default Feedback;



// WEBPACK FOOTER //
// ./src/Feedback.js